import React, { Component } from 'react';

import classNames from 'classnames';
import { Loading } from 'components/cosmos';
import { I18n } from 'components/translate';
import { PropTypes as MobxPropTypes } from 'mobx-react';
import { generateId } from 'modules/content/helper';
import PropTypes from 'prop-types';

import ChecklistItems from './ChecklistItems';
import ChecklistSelectAll from './ChecklistSelectAll';
import ChecklistSelectedItems from './ChecklistSelectedItems';

import './Checklist.scss';

class Checklist extends Component {
  checklistId = generateId();

  static Items = ChecklistItems;
  static SelectAll = ChecklistSelectAll;
  static SelectedItems = ChecklistSelectedItems;

  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    items: MobxPropTypes.arrayOrObservableArray,
    loading: PropTypes.bool,
    name: PropTypes.string,
    onChange: PropTypes.func,
    t: PropTypes.func
  };

  static defaultProps = {
    items: []
  };

  get isEmpty() {
    const { items } = this.props;

    return !items || (items && items.length === 0);
  }

  handleSelectAll = (event) => {
    const { checked } = event.target;
    const { items } = this.props;

    const newValue = items.map((item) => {
      item.checked = checked;
      return item;
    });

    this.onChange(newValue);
  };

  handleSingleChange = (event) => {
    const { items } = this.props;
    const { value, checked } = event.target;

    const checkedIndex = items.findIndex((item) => item.value === value);

    items[checkedIndex].checked = checked;

    this.onChange(items);
  };

  onChange = (items) => {
    const { onChange, name } = this.props;

    const value = items
      .filter((item) => item.checked)
      .map((item) => item.value);

    onChange && onChange({ target: { name, value } });
  };

  render() {
    const { className, loading, children, ...props } = this.props;

    const classComponent = classNames('checklist', className);

    return (
      <ul className={classComponent}>
        {!this.isEmpty &&
          React.Children.map(children, (element) =>
            this.renderChildren(element, props)
          )}

        {this.isEmpty && !loading && (
          <li className="checklist__item secondary">
            <I18n label="general.no_result_found" />
          </li>
        )}

        {loading && <Loading center />}
      </ul>
    );
  }

  renderChildren = (element, props) => {
    const newProps = {
      ...props,
      checklistId: this.checklistId,
      onChange: this.handleSingleChange
    };

    if (element.type === ChecklistSelectedItems) {
      return React.cloneElement(element, newProps);
    }

    if (element.type === ChecklistSelectAll) {
      return React.cloneElement(element, {
        ...newProps,
        onChange: this.handleSelectAll
      });
    }

    if (element.type === ChecklistItems) {
      return React.cloneElement(element, newProps);
    }

    return element;
  };
}

export default Checklist;
